import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { Form, Message, Button } from 'semantic-ui-react'
// import _find from 'lodash/find';
// import _ from 'lodash';

import XLSX from 'xlsx'
import { saveAs } from 'file-saver';

//utils
import queries from '../../../utils/queries'

import general from '../../../modulos/general';

import ImprOS from '../../../components/funcionales/impros'
import ListaDe from '../../../components/funcionales/dirmayor/listade';
import ListaCi from '../../../components/funcionales/dirmayor/listaci';
import ListaZo from '../../../components/funcionales/dirmayor/listazo';
import ListaBa from '../../../components/funcionales/dirmayor/listaba';
import selDirmayor from '../../../functions/seldirmayor';

import jsPDF from 'jspdf';
import 'jspdf-autotable';

// "use strict";

//dropdown ESTADOS
const DetalleNivel1 = props => {
  return (
    <option style={props.styles.input} value={props.elemento.estadoOS}>{props.elemento.estadoOS}</option>
  )
};

const Lista = ({styles, handleChange, list, argsDocum}) => {
  const Nivel1Detalle = list.map((elemento, i) => <DetalleNivel1 styles={styles} elemento={elemento} key={i} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="estadoos" id="miLista4" value={argsDocum.estadoos} onChange={(ev)=>handleChange(ev)}>
        <option style={styles.input} value="">Todos...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//Fin dropdown ESTADOS
//dropdown RECURSOS TECNICA
const DetalleNivelTipo = props => {
  return (
    <option dato1={props.elemento.numeroDocum} dato2={props.elemento.descrRecurso} value={props.elemento._id}>{props.elemento.numeroDocum} ={">"} {props.elemento.descrRecurso}</option>
  )
};

const ListaTecnica = ({styles, handleChange, list}) => {
  const NivelDetalleTipo = list.map((elemento, _id) => <DetalleNivelTipo elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="tecnica" id="miLista5" onChange={(ev)=>handleChange(ev)}>
        <option style={styles.input} value="">Todos...</option>
        {NivelDetalleTipo}
      </select>
    </div>
  )
};
//Fin dropdown RECURSOS TECNICA
//dropdown RECURSOS VENTAS
const DetalleNivelVentas = props => {
  return (
    <option dato1={props.elemento.numeroDocum} dato2={props.elemento.descrRecurso} value={props.elemento._id}>{props.elemento.numeroDocum} ={">"} {props.elemento.descrRecurso}</option>
  )
};

const ListaVentas = ({styles, handleChange, list}) => {
  const NivelDetalleTipo = list.map((elemento, _id) => <DetalleNivelVentas elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="ventas" id="miLista6" onChange={(ev)=>handleChange(ev)}>
        <option style={styles.input} value="">Todos...</option>
        {NivelDetalleTipo}
      </select>
    </div>
  )
};
//Fin dropdown RECURSOS VENTAS
//dropdown RECURSOS VENTAS
const DetalleNivelRecaudo = props => {
  return (
    <option dato1={props.elemento.numeroDocum} dato2={props.elemento.descrRecurso} value={props.elemento._id}>{props.elemento.numeroDocum} ={">"} {props.elemento.descrRecurso}</option>
  )
};

const ListaRecaudo = ({styles, handleChange, list}) => {
  const NivelDetalleTipo = list.map((elemento, _id) => <DetalleNivelRecaudo elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="recaudo" id="miLista7" onChange={(ev)=>handleChange(ev)}>
        <option style={styles.input} value="">Todos...</option>
        {NivelDetalleTipo}
      </select>
    </div>
  )
};
//Fin dropdown RECURSOS VENTAS
//dropdown TIPOS DE OS
const DetalleTOS1 = props => {
  return (
    <option style={props.styles.input}>{props.elemento.descrTipoOS}</option>
  )
};

const ListaTOS = ({styles, list, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleTOS1 styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="descrTipoOS" id="miListaTOS" onChange={(ev)=>handleChange(ev)}>
        <option value="">Todos...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//Fin dropdown TIPOS DE OS
//dropdown CLASIFICACIONES
const DetalleCOS = props => {
  return (
    <option style={props.styles.input}>{props.elemento.descrClasifOST}</option>
  )
};

const ListaCOS = ({styles, list, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleCOS styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="descrClasifOST" id="miListaCOS" onChange={(ev)=>handleChange(ev)}>
        <option value="">Todas...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//Fin dropdown CATEGORIAS
//dropdown CLASIFICACIONES
const DetalleCateg = props => {
  return (
    <option style={props.styles.input}>{props.elemento.descrCategOST}</option>
  )
};

const ListaCateg = ({styles, list, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleCateg styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="descrCategOST" id="miListaCateg" onChange={(ev)=>handleChange(ev)}>
        <option value="">Todas...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//Fin dropdown CATEGORIAS

//Lista de OS
const OSCli = ({elemento, argsDocum, opciones1, empresaArchFE, handleImprOSSelecc}) => {
  // if(opciones1==="opcion4"||argsDocum.estadoos!=="CERRADA"){
  if(argsDocum.estadoos!=="CERRADA"&&argsDocum.estadoos!=="Todos..."&&argsDocum.estadoos!==""){
    return(
      <tr className=''>
        <td className=''>{elemento.fechaOS}</td>
        <td className=''>{elemento.usuarioCreate}</td>
        <td className=''>{elemento.estadoOS}</td>
        <td className=''>{elemento.descrTipoOS}</td>
        <td className=''>{elemento.descrCategOST}</td>
        {/* <td className=''>{elemento.nombreCiudad}</td>
        <td className=''>{elemento.nombreZona}</td> */}
        <td className=''>{elemento.nombreBarrio}</td>
        <td className=''>{elemento.descrRecursoR}</td>
        <td className=''>{elemento.descrNodo}</td>
        <td className=''>{elemento.direccion}</td>
        {/* <td className=''>{elemento.descrRecurso}</td> */}
        <td className=''>{elemento.contrato}</td>
        <td className=''>{elemento.nombreCliente}</td>
        <td className=''>{elemento.apellidoCliente}</td>
        <td className=''>{elemento.numeroOS}</td>
        <td className=''>{elemento.ptosAdic}</td>
        <td className=''>{elemento.observacAB}</td>
        {/* <td className=''>{elemento.observacCE}</td> */}
        {(empresaArchFE==="codisert"||empresaArchFE==="supercablebq") &&
          <td className=''>{elemento.cicloFact}</td>
        }
        {empresaArchFE==="sinergy" &&
          <td className=''>{elemento.descrGrupoAfin}</td>
        }
        {(empresaArchFE==="conectic"||empresaArchFE==="supercable") &&
          <td className=''>{elemento.nombreBarrioEnOS}</td>
        }
        {(empresaArchFE==="conectic"||empresaArchFE==="supercable") &&
          <td className=''>{elemento.direccionEnOS}</td>
        }
        {(empresaArchFE==="conectic"||empresaArchFE==="supercable") &&
          <td className=''>{elemento.telefonoRef1}</td>
        }
        {(empresaArchFE==="conectic"||empresaArchFE==="supercable") &&
          <td className=''>{elemento.telefonoRef2}</td>
        }
        {(empresaArchFE==="conectic"||empresaArchFE==="supercable") &&
          <td className=''>{elemento.numeroDoc}</td>
        }
        {(empresaArchFE==="conectic"||empresaArchFE==="supercable") &&
          <td className=''>{elemento.codigoMarquilla}</td>
        }
        {(empresaArchFE==="conectic"||empresaArchFE==="supercable") &&
          <td className=''>{elemento.cun}</td>
        }
        {(empresaArchFE==="conectic"||empresaArchFE==="supercable") &&
          <td className=''>{elemento.estadoCliente}</td>
        }
        {elemento.permImprimir==="SI" &&
          <td className='center aligned'>
            <button className="ui button" style={{background: 'linear-gradient(#2c3e50, #bdc3c7, #bdc3c7 10%, #bdc3c7 10%, #bdc3c7 10%, #2c3e50)',
                color: '#89253e'}} onClick={(ev)=>handleImprOSSelecc(ev, elemento)}>
              Imprimir
            </button>
          </td>
        }
      </tr>
    )
  }
  if(argsDocum.estadoos==="Todos..."||argsDocum.estadoos===""){
    return(
      <tr className=''>
        <td className=''>{elemento.fechaOS}</td>
        <td className=''>{elemento.estadoOS}</td>
        <td className=''>{elemento.fechaCreate}</td>
        <td className=''>{elemento.usuarioCreate}</td>
        <td className=''>{elemento.usuarioClose}</td>
        <td className=''>{elemento.descrTipoOS}</td>
        <td className=''>{elemento.descrCategOST}</td>
        {/* <td className=''>{elemento.nombreCiudad}</td>
        <td className=''>{elemento.nombreZona}</td> */}
        <td className=''>{elemento.nombreBarrio}</td>
        <td className=''>{elemento.descrRecursoR}</td>
        <td className=''>{elemento.descrNodo}</td>
        <td className=''>{elemento.direccion}</td>
        {/* <td className=''>{elemento.descrRecurso}</td> */}
        <td className=''>{elemento.contrato}</td>
        <td className=''>{elemento.nombreCliente}</td>
        <td className=''>{elemento.apellidoCliente}</td>
        <td className=''>{elemento.numeroOS}</td>
        <td className=''>{elemento.ptosAdic}</td>
        <td className=''>{elemento.observacAB}</td>
        <td className=''>{elemento.observacCE}</td>
        {(empresaArchFE==="codisert"||empresaArchFE==="supercablebq") &&
          <td className=''>{elemento.cicloFact}</td>
        }
        {empresaArchFE==="sinergy" &&
          <td className=''>{elemento.descrGrupoAfin}</td>
        }
        {(empresaArchFE==="conectic"||empresaArchFE==="supercable") &&
          <td className=''>{elemento.nombreBarrioEnOS}</td>
        }
        {(empresaArchFE==="conectic"||empresaArchFE==="supercable") &&
          <td className=''>{elemento.direccionEnOS}</td>
        }
        {(empresaArchFE==="conectic"||empresaArchFE==="supercable") &&
          <td className=''>{elemento.telefonoRef1}</td>
        }
        {(empresaArchFE==="conectic"||empresaArchFE==="supercable") &&
          <td className=''>{elemento.telefonoRef2}</td>
        }
        {(empresaArchFE==="conectic"||empresaArchFE==="supercable") &&
          <td className=''>{elemento.numeroDoc}</td>
        }
        {(empresaArchFE==="conectic"||empresaArchFE==="supercable") &&
          <td className=''>{elemento.codigoMarquilla}</td>
        }
        {(empresaArchFE==="conectic"||empresaArchFE==="supercable") &&
          <td className=''>{elemento.cun}</td>
        }
        {(empresaArchFE==="conectic"||empresaArchFE==="supercable") &&
          <td className=''>{elemento.estadoCliente}</td>
        }
        {elemento.permImprimir==="SI" &&
          <td className='center aligned'>
            <button className="ui button" style={{background: 'linear-gradient(#2c3e50, #bdc3c7, #bdc3c7 10%, #bdc3c7 10%, #bdc3c7 10%, #2c3e50)',
                color: '#89253e'}} onClick={(ev)=>handleImprOSSelecc(ev, elemento)}>
              Imprimir
            </button>
          </td>
        }
      </tr>
    )
  }
  if(argsDocum.estadoos==="CERRADA"&&opciones1==="opcion4"){
    return(
      <tr className=''>
        <td className=''>{elemento.fechaOS}</td>
        <td className=''>{elemento.estadoOS}</td>
        <td className=''>{elemento.fechaCreate}</td>
        <td className=''>{elemento.usuarioCreate}</td>
        <td className=''>{elemento.usuarioClose}</td>
        <td className=''>{elemento.fechaEjec}</td>
        <td className=''>{elemento.descrTipoOS}</td>
        <td className=''>{elemento.descrCategOST}</td>
        {/* <td className=''>{elemento.nombreCiudad}</td>
        <td className=''>{elemento.nombreZona}</td> */}
        <td className=''>{elemento.nombreBarrio}</td>
        <td className=''>{elemento.descrRecursoR}</td>
        <td className=''>{elemento.descrNodo}</td>
        <td className=''>{elemento.direccion}</td>
        {/* <td className=''>{elemento.descrRecurso}</td> */}
        <td className=''>{elemento.contrato}</td>
        <td className=''>{elemento.nombreCliente}</td>
        <td className=''>{elemento.apellidoCliente}</td>
        <td className=''>{elemento.numeroOS}</td>
        <td className=''>{elemento.ptosAdic}</td>
        <td className=''>{elemento.observacAB}</td>
        <td className=''>{elemento.observacCE}</td>
        {(empresaArchFE==="codisert"||empresaArchFE==="supercablebq") &&
          <td className=''>{elemento.cicloFact}</td>
        }
        {empresaArchFE==="sinergy" &&
          <td className=''>{elemento.descrGrupoAfin}</td>
        }
        {(empresaArchFE==="conectic"||empresaArchFE==="supercable") &&
          <td className=''>{elemento.nombreBarrioEnOS}</td>
        }
        {(empresaArchFE==="conectic"||empresaArchFE==="supercable") &&
          <td className=''>{elemento.direccionEnOS}</td>
        }
        {(empresaArchFE==="conectic"||empresaArchFE==="supercable") &&
          <td className=''>{elemento.telefonoRef1}</td>
        }
        {(empresaArchFE==="conectic"||empresaArchFE==="supercable") &&
          <td className=''>{elemento.telefonoRef2}</td>
        }
        {(empresaArchFE==="conectic"||empresaArchFE==="supercable") &&
          <td className=''>{elemento.numeroDoc}</td>
        }
        {(empresaArchFE==="conectic"||empresaArchFE==="supercable") &&
          <td className=''>{elemento.codigoMarquilla}</td>
        }
        {(empresaArchFE==="conectic"||empresaArchFE==="supercable") &&
          <td className=''>{elemento.cun}</td>
        }
        {(empresaArchFE==="conectic"||empresaArchFE==="supercable") &&
          <td className=''>{elemento.estadoCliente}</td>
        }
        {elemento.permImprimir==="SI" &&
          <td className='center aligned'>
            <button className="ui button" style={{background: 'linear-gradient(#2c3e50, #bdc3c7, #bdc3c7 10%, #bdc3c7 10%, #bdc3c7 10%, #2c3e50)',
                color: '#89253e'}} onClick={(ev)=>handleImprOSSelecc(ev, elemento)}>
              Imprimir
            </button>
          </td>
        }
      </tr>
    )
  }

  if(argsDocum.estadoos==="CERRADA"&&opciones1==="opcion5"){
    return(
      <tr className=''>
        <td className=''>{elemento.fechaOS}</td>
        <td className=''>{elemento.estadoOS}</td>
        <td className=''>{elemento.usuarioClose}</td>
        <td className=''>{elemento.descrTipoOS}</td>
        {/* <td className=''>{elemento.nombreCiudad}</td>
        <td className=''>{elemento.nombreZona}</td> */}
        <td className=''>{elemento.nombreBarrio}</td>
        <td className=''>{elemento.descrRecursoR}</td>
        <td className=''>{elemento.descrNodo}</td>
        <td className=''>{elemento.direccion}</td>
        {/* <td className=''>{elemento.descrRecurso}</td> */}
        <td className=''>{elemento.contrato}</td>
        <td className=''>{elemento.nombreCliente}</td>
        <td className=''>{elemento.apellidoCliente}</td>
        <td className=''>{elemento.numeroOS}</td>
        <td className=''>{elemento.descrRecursoV}</td>
        <td className=''>{elemento.descripcionServicio}</td>
        <td className='right aligned'>{elemento.valorTotal?general.formatNum(elemento.valorTotal.toString()):0}</td>
        {(empresaArchFE==="codisert"||empresaArchFE==="supercablebq") &&
          <td className=''>{elemento.cicloFact}</td>
        }
        {empresaArchFE==="sinergy" &&
          <td className=''>{elemento.descrGrupoAfin}</td>
        }
        {(empresaArchFE==="conectic"||empresaArchFE==="supercable") &&
          <td className=''>{elemento.nombreBarrioEnOS}</td>
        }
        {(empresaArchFE==="conectic"||empresaArchFE==="supercable") &&
          <td className=''>{elemento.direccionEnOS}</td>
        }
        {(empresaArchFE==="conectic"||empresaArchFE==="supercable") &&
          <td className=''>{elemento.telefonoRef1}</td>
        }
        {(empresaArchFE==="conectic"||empresaArchFE==="supercable") &&
          <td className=''>{elemento.telefonoRef2}</td>
        }
        {(empresaArchFE==="conectic"||empresaArchFE==="supercable") &&
          <td className=''>{elemento.numeroDoc}</td>
        }
        {(empresaArchFE==="conectic"||empresaArchFE==="supercable") &&
          <td className=''>{elemento.codigoMarquilla}</td>
        }
        {(empresaArchFE==="conectic"||empresaArchFE==="supercable") &&
          <td className=''>{elemento.cun}</td>
        }
        {(empresaArchFE==="conectic"||empresaArchFE==="supercable") &&
          <td className=''>{elemento.estadoCliente}</td>
        }
      </tr>
    )
  }
  if(argsDocum.estadoos==="CERRADA"&&opciones1==="opcion6"){
    return(
      <tr className=''>
        <td className=''>{elemento.fechaOS}</td>
        <td className=''>{elemento.estadoOS}</td>
        <td className=''>{elemento.usuarioClose}</td>
        <td className=''>{elemento.descrTipoOS}</td>
        <td className=''>{elemento.descrCategOST}</td>
        {/* <td className=''>{elemento.nombreCiudad}</td>
        <td className=''>{elemento.nombreZona}</td> */}
        <td className=''>{elemento.nombreBarrio}</td>
        <td className=''>{elemento.descrRecursoR}</td>
        <td className=''>{elemento.descrNodo}</td>
        <td className=''>{elemento.direccion}</td>
        {/* <td className=''>{elemento.descrRecurso}</td> */}
        <td className=''>{elemento.contrato}</td>
        <td className=''>{elemento.nombreCliente}</td>
        <td className=''>{elemento.apellidoCliente}</td>
        <td className=''>{elemento.numeroOS}</td>
        <td className=''>{elemento.descrRecursoV}</td>
        <td className=''>{elemento.descripcionServicio}</td>
        <td className='right aligned'>{elemento.valorServicios?general.formatNum(elemento.valorServicios.toString()):0}</td>
        {(empresaArchFE==="codisert"||empresaArchFE==="supercablebq") &&
          <td className=''>{elemento.cicloFact}</td>
        }
        {empresaArchFE==="sinergy" &&
          <td className=''>{elemento.descrGrupoAfin}</td>
        }
        {(empresaArchFE==="conectic"||empresaArchFE==="supercable") &&
          <td className=''>{elemento.nombreBarrioEnOS}</td>
        }
        {(empresaArchFE==="conectic"||empresaArchFE==="supercable") &&
          <td className=''>{elemento.direccionEnOS}</td>
        }
        {(empresaArchFE==="conectic"||empresaArchFE==="supercable") &&
          <td className=''>{elemento.telefonoRef1}</td>
        }
        {(empresaArchFE==="conectic"||empresaArchFE==="supercable") &&
          <td className=''>{elemento.telefonoRef2}</td>
        }
        {(empresaArchFE==="conectic"||empresaArchFE==="supercable") &&
          <td className=''>{elemento.numeroDoc}</td>
        }
        {(empresaArchFE==="conectic"||empresaArchFE==="supercable") &&
          <td className=''>{elemento.codigoMarquilla}</td>
        }
        {(empresaArchFE==="conectic"||empresaArchFE==="supercable") &&
          <td className=''>{elemento.cun}</td>
        }
        {(empresaArchFE==="conectic"||empresaArchFE==="supercable") &&
          <td className=''>{elemento.estadoCliente}</td>
        }
      </tr>
    )
  }
};

const ListaOS = ({list, argsDocum, opciones1, empresaArchFE, handleImprOSSelecc}) => {
  const nivel1Detalle = list.map((elemento, i) => <OSCli elemento={elemento} key={i}
    argsDocum={argsDocum} opciones1={opciones1} empresaArchFE={empresaArchFE}
    handleImprOSSelecc={handleImprOSSelecc}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

// let fechaHoy = new Date()
// fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())
// console.log(fechaHoy)
// let argsBuscarOS = {fechaCreate: { $gte: fechaHoy, $lte: fechaHoy }}
// let argsBuscarOS = {fechaCreate: null, fechaEjec: null}

let argsBuscarOS = {tipoqry: `[{$match: {fechaCreate: null, fechaEjec: null}},{$lookup: {from: 'clientes', localField: 'contrato', foreignField: 'contrato', as: 'cliente'}}]`}

// const argsBuscarCL = {numDocum: 2027}

class RtesOS2 extends React.Component {
  state={argsDocum: {_id: "",  hoy: "",  desde: "",  hasta: "", numeroDocum: "", descrRecurso: "Todos...",
        numeroDocumV: "", descrRecursoV: "Todos...", numeroDocumR: "", descrRecursoR: "Todos...",
        estadoos: "ABIERTA", descrTipoOS: "Todos...",
        descrClasifOST: "Todas...", descrCategOST: "Todas...",
        descrDpto: "Todos...", nombreCiudad: "Todas...", nombreZona: "Todas...",
        nombreBarrio: "Todos...", checkDiasMoraIni: false},
        opciones: "opcion1", opciones1: "opcion4", stImpr: false,
        imprSelecc: 0, argsSelDpto: this.props.argsSelDpto,
        listRtes: [], totOS: 0, confirmaAct: false, open: false, errors: []}

  handleChange = (ev) => {
    // console.log(ev.target.name)
    // console.log(ev.target.value)
    const argsDocum = this.state.argsDocum
    // let argsBuscarOS = {}
    let miLista5 = document.getElementById("miLista5");
    let miLista6 = document.getElementById("miLista6");
    let miLista7 = document.getElementById("miLista7");
    let listRtes = []
    this.setState({listRtes})

    if(ev.target.name==="opciones"||ev.target.name==="opciones1"){
      if(ev.target.checked===true){
        if(ev.target.name==="opciones"){
          this.setState({opciones: ev.target.value})
        }else{
          this.setState({opciones1: ev.target.value})
        }
      }
    }else{
      if(ev.target.name === "tecnica"){
        if(miLista5.options[miLista5.selectedIndex].text==="Todos..."){
          argsDocum['numeroDocum'] = ""
          argsDocum['descrRecurso'] = miLista5.options[miLista5.selectedIndex].text
        }else{
          argsDocum['numeroDocum'] = miLista5.options[miLista5.selectedIndex].attributes[0].value
          argsDocum['descrRecurso'] = miLista5.options[miLista5.selectedIndex].attributes[1].value
        }
      }else{
        if(ev.target.name === "ventas"){
          if(miLista6.options[miLista6.selectedIndex].text==="Todos..."){
            argsDocum['numeroDocumV'] = ""
            argsDocum['descrRecursoV'] = miLista6.options[miLista6.selectedIndex].text
          }else{
            argsDocum['numeroDocumV'] = miLista6.options[miLista6.selectedIndex].attributes[0].value
            argsDocum['descrRecursoV'] = miLista6.options[miLista6.selectedIndex].attributes[1].value
          }
        }else{
          if(ev.target.name === "recaudo"){
            if(miLista7.options[miLista7.selectedIndex].text==="Todos..."){
              argsDocum['numeroDocumR'] = ""
              argsDocum['descrRecursoR'] = miLista7.options[miLista7.selectedIndex].text
            }else{
              argsDocum['numeroDocumR'] = miLista7.options[miLista7.selectedIndex].attributes[0].value
              argsDocum['descrRecursoR'] = miLista7.options[miLista7.selectedIndex].attributes[1].value
            }
          }else{
            if(ev.target.name === "estadoos"){
              this.setState({opciones1: "opcion4"})
            }
            if(ev.target.name === "checkDiasMoraIni"){
              argsDocum[ev.target.name] = ev.target.checked
            }else{
              argsDocum[ev.target.name] = ev.target.value
              if(ev.target.name==="descrTipoOS"){
                argsDocum['descrCategOST'] = "Todas..."
              }
            }
          }
        }
      }
    }

    this.setState({argsDocum});
    this.setState({stImpr: false})
    // console.log(argsBuscarOS)
    // console.log(argsDocum.estadoos)
  }

  handleImprOSSelecc = async (ev, elemento)=>{
    // console.log(elemento)
    this.setState({stImpr: true, imprSelecc: elemento.numeroOS})
  }

  handleSubmit = async (ev, argsDocum, opciones, opciones1)=>{
    // console.log(ev.target.name)
    // console.log(argsDocum)
    let targetName = ev.target.name
    // console.log(opciones)
    if(targetName==="pantalla"){
      document.body.style.cursor = 'wait'

      // let fechaHoy = new Date()
      // fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())
      let argsUpd
      let errors = []
      // if(!this.props.allCliBasico.allCliBasico||!this.props.allOdeSRtes.allOdeSRtes){
      //   errors.push({path: "O de S", message: "Proceso de cargue de la información, por favor espere un momento..."});
      // }
      if(!this.props.allOdeSRtes.allOdeSRtes){
        errors.push({path: "O de S", message: "Proceso de cargue de la información, por favor espere un momento..."});
      }
      if(!this.state.argsDocum.desde){
        errors.push({path: "Desde", message: "Debe seleccionar la fecha inicial del reporte"});
      }
      if(!this.state.argsDocum.hasta){
        errors.push({path: "Hasta", message: "Debe seleccionar la fecha final del reporte"});
      }
  
      // console.log(this.state.argsDocum)
      this.setState({errors})
      if(errors.length===0){
        let argsBuscarOS="", argsBuscarOSCl=""

//Seleccionar clientes del dpto, ciudad, zona y barrio seleccionados
// console.log(this.state.argsSelDpto.descrDpto)
        if(this.state.argsSelDpto.descrDpto===undefined||this.state.argsSelDpto.descrDpto==="Todos..."){

        }else{
          if(this.state.argsSelDpto.nombreCiudad===undefined||this.state.argsSelDpto.nombreCiudad==="Todas..."){
            if(argsBuscarOSCl){argsBuscarOSCl += `, `}
            argsBuscarOSCl += `'cliente.dirmayor.descrDpto': '${this.state.argsSelDpto.descrDpto}'`
          }else{
            if(this.state.argsSelDpto.nombreZona===undefined||this.state.argsSelDpto.nombreZona==="Todas..."){
              if(argsBuscarOSCl){argsBuscarOSCl += `, `}
                argsBuscarOSCl += `'cliente.dirmayor.descrDpto': '${this.state.argsSelDpto.descrDpto}', 
                  'cliente.dirmayor.ciudades.nombreCiudad': '${this.state.argsSelDpto.nombreCiudad}'`
            }else{
              if(this.state.argsSelDpto.nombreBarrio===undefined||this.state.argsSelDpto.nombreBarrio==="Todos..."){
                if(argsBuscarOSCl){argsBuscarOSCl += `, `}
                  argsBuscarOSCl += `'cliente.dirmayor.descrDpto': '${this.state.argsSelDpto.descrDpto}', 
                    'cliente.dirmayor.ciudades.nombreCiudad': '${this.state.argsSelDpto.nombreCiudad}', 
                    'cliente.dirmayor.ciudades.zonas.nombreZona': '${this.state.argsSelDpto.nombreZona}'`
              }else{
                if(argsBuscarOSCl){argsBuscarOSCl += `, `}
                  argsBuscarOSCl += `'cliente.dirmayor.descrDpto': '${this.state.argsSelDpto.descrDpto}', 
                    'cliente.dirmayor.ciudades.nombreCiudad': '${this.state.argsSelDpto.nombreCiudad}', 
                    'cliente.dirmayor.ciudades.zonas.nombreZona': '${this.state.argsSelDpto.nombreZona}', 
                    'cliente.dirmayor.ciudades.zonas.barrios.nombreBarrio': '${this.state.argsSelDpto.nombreBarrio}'`
              }
            }
          }
        }

        // let clientesOS = []
        // if(!this.state.argsSelDpto.descrDpto||this.state.argsSelDpto.descrDpto==="Todos..."){
        //   clientesOS = this.props.allCliBasico.allCliBasico
        // }else{
        //   if(!this.state.argsSelDpto.nombreCiudad||this.state.argsSelDpto.nombreCiudad==="Todas..."){
        //     clientesOS = this.props.allCliBasico.allCliBasico.filter(elemento => 
        //       elemento.dirmayor.descrDpto===this.state.argsSelDpto.descrDpto)
        //   }else{
        //     if(!this.state.argsSelDpto.nombreZona||this.state.argsSelDpto.nombreZona==="Todas..."){
        //       clientesOS = this.props.allCliBasico.allCliBasico.filter(elemento => 
        //         elemento.dirmayor.descrDpto===this.state.argsSelDpto.descrDpto&&
        //         elemento.dirmayor.ciudades.nombreCiudad===this.state.argsSelDpto.nombreCiudad)
        //     }else{
        //       if(!this.state.argsSelDpto.nombreBarrio||this.state.argsSelDpto.nombreBarrio==="Todos..."){
        //         clientesOS = this.props.allCliBasico.allCliBasico.filter(elemento =>
        //           elemento.dirmayor.descrDpto===this.state.argsSelDpto.descrDpto&&
        //           elemento.dirmayor.ciudades.nombreCiudad===this.state.argsSelDpto.nombreCiudad&&
        //           elemento.dirmayor.ciudades.zonas.nombreZona===this.state.argsSelDpto.nombreZona)
        //       }else{
        //         clientesOS = this.props.allCliBasico.allCliBasico.filter(elemento =>
        //           elemento.dirmayor.descrDpto===this.state.argsSelDpto.descrDpto&&
        //           elemento.dirmayor.ciudades.nombreCiudad===this.state.argsSelDpto.nombreCiudad&&
        //           elemento.dirmayor.ciudades.zonas.nombreZona===this.state.argsSelDpto.nombreZona&&
        //           elemento.dirmayor.ciudades.zonas.barrios.nombreBarrio===this.state.argsSelDpto.nombreBarrio)
        //       }
        //     }
        //   }
        // }

        // console.log(clientesOS)
        // console.log(this.props.allOdeSRtes.allOdeSRtes)
        // console.log(this.state.argsDocum)
        let listRtes = []
        let totOS = 0

        //os ABIERTA => no filtra por fechas, las presenta todas
        // if(argsDocum.estadoos!=="ABIERTA"){
        //   if(argsDocum.estadoos==="Todos..."||argsDocum.estadoos===""){
        //     argsBuscarOS += `fechaCreate: { $gte: new Date('${argsDocum.desde}'), $lte: new Date('${argsDocum.hasta}') }`
        //   }else{
        //     argsBuscarOS += `fechaEjec: { $gte: new Date('${argsDocum.desde}'), $lte: new Date('${argsDocum.hasta}') }`
        //   }
        // }
        let estadoos = argsDocum.estadoos
        if(argsDocum.estadoos===""){
          estadoos = 'Todos...'
        }
        if(this.props.empresa.empresaArchFE==="codisert"){
          switch(estadoos){
            case ('Todos...'||''):
              argsBuscarOS += `fechaCreate: { $gte: new Date('${argsDocum.desde}'), $lte: new Date('${argsDocum.hasta}') }`
              break
            case ('ABIERTA'):
              argsBuscarOS += `fechaCreate: { $gte: new Date('${argsDocum.desde}'), $lte: new Date('${argsDocum.hasta}') }`
              break
            case 'CERRADA':
              argsBuscarOS += `fechaClose: { $gte: new Date('${argsDocum.desde}'), $lte: new Date('${argsDocum.hasta}') }`
              break
            case 'CANCELADA':
              argsBuscarOS += `fechaCanc: { $gte: new Date('${argsDocum.desde}'), $lte: new Date('${argsDocum.hasta}') }`
              break
            default:
              break
          }
        }else{
          switch(estadoos){
            case ('Todos...'||''):
              argsBuscarOS += `fechaCreate: { $gte: new Date('${argsDocum.desde}'), $lte: new Date('${argsDocum.hasta}') }`
              break
            case 'CERRADA':
              argsBuscarOS += `fechaClose: { $gte: new Date('${argsDocum.desde}'), $lte: new Date('${argsDocum.hasta}') }`
              break
            case 'CANCELADA':
              argsBuscarOS += `fechaCanc: { $gte: new Date('${argsDocum.desde}'), $lte: new Date('${argsDocum.hasta}') }`
              break
            default:
              break
          }
        }

        if(argsDocum.checkDiasMoraIni){
          if(argsBuscarOS){argsBuscarOS += `, `}
          argsBuscarOS += `'ptosAdic': {$gt: 0}`
        }

        if(this.state.argsDocum.descrTipoOS&&this.state.argsDocum.descrTipoOS!=="Todos..."){
          if(argsBuscarOS){argsBuscarOS += `, `}
          argsBuscarOS += `'tipoos.descrTipoOS': '${argsDocum.descrTipoOS}'`
        }

        if(this.state.argsDocum.descrClasifOST&&this.state.argsDocum.descrClasifOST!=="Todas..."){
          if(argsBuscarOS){argsBuscarOS += `, `}
          argsBuscarOS += `'descrClasifOST': '${argsDocum.descrClasifOST}'`
        }
        if(this.state.argsDocum.descrCategOST&&this.state.argsDocum.descrCategOST!=="Todas..."){
          if(argsBuscarOS){argsBuscarOS += `, `}
          argsBuscarOS += `'descrCategOST': '${argsDocum.descrCategOST}'`
        }

        if(this.state.argsDocum.descrRecursoV&&this.state.argsDocum.descrRecursoV!=="Todos..."){
          if(argsBuscarOS){argsBuscarOS += `, `}
          argsBuscarOS += `'descrRecursoV': '${argsDocum.descrRecursoV}'`
        }

        // let movimOS = []
        // console.log(argsDocum.estadoos)
        if(argsDocum.estadoos==="Todos..."||argsDocum.estadoos===""){
          // movimOS = this.props.allOdeSRtes.allOdeSRtes
        }else{
          // console.log(argsDocum.estadoos)
          // movimOS = this.props.allOdeSRtes.allOdeSRtes.filter(movim => movim.estadoOS===argsDocum.estadoos)

          if(argsBuscarOS){argsBuscarOS += `, `}
          argsBuscarOS += `'estadoOS': '${argsDocum.estadoos}'`
        }
        // console.log(opciones)
        if(opciones==="opcion1"){
          // movimOS = movimOS.filter(movim => movim.impresa===false)

          if(argsBuscarOS){argsBuscarOS += `, `}
          argsBuscarOS += `'impresa': false`
        }
        if(opciones==="opcion2"){
          // movimOS = movimOS.filter(movim => movim.impresa===true)

          if(argsBuscarOS){argsBuscarOS += `, `}
          argsBuscarOS += `'impresa': true`
        }

        argsBuscarOS = '{' + argsBuscarOS + '}'
        if(argsBuscarOSCl){
          argsBuscarOSCl = '{' + argsBuscarOSCl + '}'
          argsBuscarOS = {tipoqry: `[{$match: ${argsBuscarOS}},
            {$lookup: {from: 'clientes', localField: 'contrato', foreignField: 'contrato', as: 'cliente'}},
            {$lookup: {
              from: "tipoosses", let: {codigoTipoOS: "$tipoos.codigoTipoOS"},
              pipeline: [
                {$match: {$expr: {$eq: ["$codigoTipoOS", "$$codigoTipoOS"]}}},
                {$project: {permImprimir: 1, _id: 0 }}
              ],
              as: "tipodeos"
            }},
            {$unwind: '$tipodeos'},
            {$addFields: {permImprimir: '$tipodeos.permImprimir'}},
            {$match: ${argsBuscarOSCl}}
          ]`}
        }else{
          argsBuscarOS = {tipoqry: `[{$match: ${argsBuscarOS}},
            {$lookup: {from: 'clientes', localField: 'contrato', foreignField: 'contrato', as: 'cliente'}},
            {$lookup: {
              from: "tipoosses", let: {codigoTipoOS: "$tipoos.codigoTipoOS"},
              pipeline: [
                {$match: {$expr: {$eq: ["$codigoTipoOS", "$$codigoTipoOS"]}}},
                {$project: {permImprimir: 1, _id: 0 }}
              ],
              as: "tipodeos"
            }},
            {$unwind: '$tipodeos'},
            {$addFields: {permImprimir: '$tipodeos.permImprimir'}}
          ]`}
        }

        let movimOS = []
        // console.log(argsBuscarOS)
        let {data} = await this.props.allOdeSRtes.refetch(argsBuscarOS)
        movimOS = await data.allOdeSRtes
        // console.log(movimOS)
        movimOS.forEach(async (elemento1, i) => {
          // const indexSearch = clientesOS.findIndex( cliente => cliente.contrato===elemento1.contrato )
          // if(indexSearch!==-1){
          //   let elemento = clientesOS[indexSearch]
// console.log(elemento1)
          if(elemento1.cliente[0]){
            let elemento = elemento1.cliente[0]
    
    // clientesOS.forEach(async (elemento, _id) => {
          // console.log(elemento)
            // let siRecursos = false
            // console.log(movimOS)
            // movimOS.forEach((elemento1, i) => {
            let recOK = false
            if(argsDocum.descrRecurso!=="Todos..."){
              elemento1.recursos.forEach((elemento2, i) => {
                if(argsDocum.descrRecurso===elemento2.descrRecurso){
                  recOK = true
                }
              })
            }else{
              recOK = true
            }
            if(argsDocum.descrRecursoR!=="Todos..."){
              if(argsDocum.descrRecursoR!=="Todos..."){
                if(argsDocum.descrRecursoR!==elemento.dirmayor.ciudades.zonas.barrios.descrRecursoR){
                  recOK = false
                }
              }
            }
            if(recOK){
                argsUpd = {}
                let nombreBarrio = "", nombreBarrio_OS = ""
                let descrRecursoR = ""
                if(elemento.dirmayor&&elemento.dirmayor.ciudades&&elemento.dirmayor.ciudades.zonas&&elemento.dirmayor.ciudades.zonas.barrios&&elemento.dirmayor.ciudades.zonas.barrios.nombreBarrio){
                  nombreBarrio = elemento.dirmayor.ciudades.zonas.barrios.nombreBarrio
                  descrRecursoR = elemento.dirmayor.ciudades.zonas.barrios.descrRecursoR

                  if(elemento1.dirmayor&&elemento1.dirmayor.ciudades&&elemento1.dirmayor.ciudades.zonas&&elemento1.dirmayor.ciudades.zonas.barrios&&elemento1.dirmayor.ciudades.zonas.barrios.nombreBarrio){
                    nombreBarrio_OS = elemento1.dirmayor.ciudades.zonas.barrios.nombreBarrio
                  }
                }else{
                  if(elemento1.dirmayor&&elemento1.dirmayor.ciudades){
                    nombreBarrio = elemento1.dirmayor.ciudades.zonas.barrios.nombreBarrio
                    descrRecursoR = elemento1.dirmayor.ciudades.zonas.barrios.descrRecursoR

                    nombreBarrio_OS = nombreBarrio
                  }                
                }

                let linea1DNN = "", linea1DNN_OS = ""
                if(elemento.direccion&&elemento.direccion.descrTipoVia1){
                  linea1DNN = elemento.direccion.descrTipoVia1?elemento.direccion.descrTipoVia1:""
                  linea1DNN += elemento.direccion.numeroTipoVia1?" " + elemento.direccion.numeroTipoVia1:""
                  linea1DNN += elemento.direccion.descrTipoVia2?" " + elemento.direccion.descrTipoVia2:""
                  linea1DNN += elemento.direccion.numeroTipoVia2?" " + elemento.direccion.numeroTipoVia2:""
                  linea1DNN += elemento.direccion.numeroTipoVia2F?" " + elemento.direccion.numeroTipoVia2F:""
                  linea1DNN += elemento.direccion.descrTipoUnd1?" " + elemento.direccion.descrTipoUnd1:""
                  linea1DNN += elemento.direccion.numeroTipoUnd1?" " + elemento.direccion.numeroTipoUnd1:""
                  linea1DNN += elemento.direccion.descrTipoUnd2?" " + elemento.direccion.descrTipoUnd2:""
                  linea1DNN += elemento.direccion.numeroTipoUnd2?" " + elemento.direccion.numeroTipoUnd2:""
                  linea1DNN = linea1DNN.substring(0, 40)

                  if(elemento1.direccion&&elemento1.direccion.descrTipoVia1){
                    linea1DNN_OS = elemento1.direccion.descrTipoVia1?elemento1.direccion.descrTipoVia1:""
                    linea1DNN_OS += elemento1.direccion.numeroTipoVia1?" " + elemento1.direccion.numeroTipoVia1:""
                    linea1DNN_OS += elemento1.direccion.descrTipoVia2?" " + elemento1.direccion.descrTipoVia2:""
                    linea1DNN_OS += elemento1.direccion.numeroTipoVia2?" " + elemento1.direccion.numeroTipoVia2:""
                    linea1DNN_OS += elemento1.direccion.numeroTipoVia2F?" " + elemento1.direccion.numeroTipoVia2F:""
                    linea1DNN_OS += elemento1.direccion.descrTipoUnd1?" " + elemento1.direccion.descrTipoUnd1:""
                    linea1DNN_OS += elemento1.direccion.numeroTipoUnd1?" " + elemento1.direccion.numeroTipoUnd1:""
                    linea1DNN_OS += elemento1.direccion.descrTipoUnd2?" " + elemento1.direccion.descrTipoUnd2:""
                    linea1DNN_OS += elemento1.direccion.numeroTipoUnd2?" " + elemento1.direccion.numeroTipoUnd2:""
                    linea1DNN_OS = linea1DNN_OS.substring(0, 40)
                  }
                }else{
                  if(elemento1.direccion&&elemento1.direccion.descrTipoVia1){
                    linea1DNN = elemento1.direccion.descrTipoVia1?elemento1.direccion.descrTipoVia1:""
                    linea1DNN += elemento1.direccion.numeroTipoVia1?" " + elemento1.direccion.numeroTipoVia1:""
                    linea1DNN += elemento1.direccion.descrTipoVia2?" " + elemento1.direccion.descrTipoVia2:""
                    linea1DNN += elemento1.direccion.numeroTipoVia2?" " + elemento1.direccion.numeroTipoVia2:""
                    linea1DNN += elemento1.direccion.numeroTipoVia2F?" " + elemento1.direccion.numeroTipoVia2F:""
                    linea1DNN += elemento1.direccion.descrTipoUnd1?" " + elemento1.direccion.descrTipoUnd1:""
                    linea1DNN += elemento1.direccion.numeroTipoUnd1?" " + elemento1.direccion.numeroTipoUnd1:""
                    linea1DNN += elemento1.direccion.descrTipoUnd2?" " + elemento1.direccion.descrTipoUnd2:""
                    linea1DNN += elemento1.direccion.numeroTipoUnd2?" " + elemento1.direccion.numeroTipoUnd2:""
                    linea1DNN = linea1DNN.substring(0, 40)
                    linea1DNN_OS = linea1DNN.substring(0, 40)
                  }
                }

                argsUpd = {
                  // "fechaOS": elemento1.estadoOS==="ABIERTA"?elemento1.fechaCreate.substr(0, 10):elemento1.fechaEjec.substr(0, 10),
                  "fechaOS": elemento1.estadoOS==="ABIERTA"?elemento1.fechaCreate.substr(0, 10):elemento1.estadoOS==="CANCELADA"?elemento1.fechaCanc.substr(0, 10):elemento1.horaClose?elemento1.fechaClose.substr(0, 10) + ' ' + elemento1.horaClose:elemento1.fechaClose.substr(0, 10),
                  "fechaCreate": elemento1.fechaCreate.substr(0, 10),
                  "usuarioCreate": elemento1.usuarioCreate,
                  "usuarioClose": elemento1.usuarioClose,
                  "fechaEjec": elemento1.fechaEjec.substr(0, 10),
                  "estadoOS": elemento1.estadoOS,
                  "descrTipoOS": elemento1.tipoos.descrTipoOS,
                  "descrClasifOST": elemento1.tipoos.descrClasifOST,
                  "nombreBarrio": nombreBarrio,
                  "descrRecursoR": descrRecursoR,
                  "descrNodo": elemento1.descrNodo,
                  "direccion": linea1DNN,
                  "contrato": elemento.contrato,
                  "nombreCliente": elemento.nombreCliente,
                  "apellidoCliente": elemento.apellidoCliente,
                  "estadoCliente": elemento.estadoCliente?elemento.estadoCliente: "",
                  "telefono1": elemento.telefono1,
                  "telefono2": elemento.telefono2,
                  "codigoMarquilla": elemento.codigoMarquilla,
                  "numeroOS": elemento1.numeroOS,
                  "ptosAdic": elemento1.ptosAdic,
                  "observacAB": elemento1.observacAB,
                  "observacCE": elemento1.observacCE,
                  "cliente": elemento1.cliente,
                  "cicloFact": elemento.cicloFact?elemento.cicloFact:"",
                  "descrCategOST": elemento1.descrCategOST?elemento1.descrCategOST:"",
                  "cun": elemento1.cun?elemento1.cun:"",
                  "descrGrupoAfin": elemento.grupoaf.descrGrupoAfin,
                  "direccionEnOS": linea1DNN_OS,
                  "telefonoRef1": elemento.telefonoRef1,
                  "telefonoRef2": elemento.telefonoRef2,
                  "permImprimir": elemento1.permImprimir,
                  "nombreBarrioEnOS": nombreBarrio_OS,
                  "numeroDoc": elemento.numeroDoc
                }
                // console.log(elemento)
                if(opciones1==="opcion4"||argsDocum.estadoos!=="CERRADA"){
                  listRtes.push(argsUpd)
                  totOS += 1
                }
                if(argsDocum.estadoos==="CERRADA"&&opciones1==="opcion5"){
                  // console.log(elemento1.cargoFra)
                  if(elemento1.cargoFra&&elemento1.cargoFra.length>0){
                    totOS += 1
                    elemento1.cargoFra.forEach((elemento2, i) => {
                      let argsUpdCF = {...argsUpd}
                      argsUpdCF.descrRecursoV = elemento1.descrRecursoV
                      argsUpdCF.descripcionServicio = elemento2.descripcionServicio
                      argsUpdCF.valorTotal = elemento2.valorTotal
                      listRtes.push(argsUpdCF)
                    })
                  }
                }
                if(argsDocum.estadoos==="CERRADA"&&opciones1==="opcion6"){
                  if(elemento1.tarifa&&elemento1.tarifa.servicios&&elemento1.tarifa.servicios.length>0){
                    totOS += 1
                    elemento1.tarifa.servicios.forEach((elemento2, i) => {
                      let argsUpdCF = {...argsUpd}
                      argsUpdCF.descrRecursoV = elemento1.descrRecursoV
                      argsUpdCF.descripcionServicio = elemento2.descripcionServicio
                      argsUpdCF.valorServicios = elemento2.valorServicios
                      listRtes.push(argsUpdCF)
                    })
                  }
                }
              // }
              
            }
            // })
          }
        })
        // console.log(listRtes)
        this.setState({listRtes})
        this.setState({totOS})
      }
      document.body.style.cursor = 'default'
    }
    if(targetName==="pdf"){
      var doc = new jsPDF({orientation: 'l', unit: 'mm', format: 'letter'})
      doc.setFontSize(14);
      doc.setFontType("bold");
      let texto1 = this.props.empresa.empresaRazonSocial
      let texto2 = "ORDENES DE SERVICIO"
      // const fechaHoy = new Date()
      // let agnoHoy = fechaHoy.getFullYear()
      // let mesHoy = ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1))
      // mesHoy = agnoHoy + "-" + mesHoy
      // let mesMsg = ""
      // argsDocum.mes?mesMsg=argsDocum.mes:mesMsg=mesHoy
      let tit1Texto3 = argsDocum.desde
      let tit2Texto3 = argsDocum.hasta
      let texto3 = `${tit1Texto3} - ${tit2Texto3}`
      doc.text(texto1, 108, 20, 'center')
      doc.setFontSize(12);
      doc.text(texto2, 108, 30, 'center')
      doc.setFontSize(10);
      doc.text(texto3, 108, 40, 'center')
  
      var source = document.getElementById("tabla");
      doc.autoTable({startY: 45,
                      tableLineColor: "blue",
                      tableLineWidth: 0.1,
                      styles: {
                        // font: 'Calibri',
                        fontSize: 10,
                        lineColor: "black",
                        lineWidth: 0.1
                      },
                      headStyles: {
                        fillColor: "#bdc3c7",
                        textColor: "black",
                        fontSize: 12
                      },
                      bodyStyles: {
                        fillColor: "#E9E4F0",
                        textColor: "black"
                      },
                      alternateRowStyles: {
                        fillColor: "white",
                        textColor: "black"
                      },
                      html: source,
                      margin: {top: 10, left: 2, right: 2},})
      // let finalY = doc.previousAutoTable.finalY; //para traer posicion final de la tabla
      // doc.text("TOTAL", 50, finalY + 15);
      doc.autoPrint({variant: 'non-conform'});
      // doc.output('dataurlnewwindow'); //abre el pdf en una nueva ventana // OJOOO YA NO FUNCIONA
      // => UTILIZAR
      const pdfBlob = doc.output('blob');
      const url = URL.createObjectURL(pdfBlob);
      window.open(url);
      // doc.save('odes.pdf')
    }

    if(targetName==="excel"){
      let xlsString = []
      let listRtes = this.state.listRtes
// console.log(listRtes)
      let xlsString1 = []
      // if(opciones1==="opcion4"||argsDocum.estadoos!=="CERRADA"){
      let estadoClienteEncab = ""
      let cicloFactEncab = "", direccionEnOSEncab = ""
      let telefonoRef1Encab = "", telefonoRef2Encab = ""
      let numeroDocEncab = "", codigoMarquillaEncab = "", cunEncab = ""
      if(this.props.empresa.empresaArchFE==="codisert"||this.props.empresa.empresaArchFE==="sinergy"||
          this.props.empresa.empresaArchFE==="conectic"||this.props.empresa.empresaArchFE==="supercable"||
          this.props.empresa.empresaArchFE==="supercablebq"){
        if(this.props.empresa.empresaArchFE==="codisert"||this.props.empresa.empresaArchFE==="supercablebq"){
          cicloFactEncab = "Ciclo"
        }
        if(this.props.empresa.empresaArchFE==="sinergy"){
          cicloFactEncab = "Grupo Afinidad"
        }
        if(this.props.empresa.empresaArchFE==="conectic"||this.props.empresa.empresaArchFE==="supercable"){
          estadoClienteEncab = "Estado cliente"
          cicloFactEncab = "Barrio en OS"
          direccionEnOSEncab = "Dirección en OS"
          telefonoRef1Encab = "Tel Ref 1"
          telefonoRef2Encab = "Tel Ref 2"
          numeroDocEncab = "Documento"
          codigoMarquillaEncab = "Marquilla"
          cunEncab = "CUN"
        }
      }
      if(argsDocum.estadoos!=="CERRADA"&&argsDocum.estadoos!=="Todos..."&&argsDocum.estadoos!==""){
        xlsString1 = ['Fecha',  'Usuario Crea', 'Estado', 'Tipo de OS', 'Categoría', 'Barrio', 'Recauda', 'Nodo', 'Dirección', 'Teléfono 1', 'Teléfono 2',
          'Contrato', 'Nombre(s)', 'Apellido(s)', '# OS', 'Ptos Adic', 'Observac al crear', cicloFactEncab, direccionEnOSEncab, telefonoRef1Encab, telefonoRef2Encab, numeroDocEncab, codigoMarquillaEncab, cunEncab, estadoClienteEncab]
      }
      if(argsDocum.estadoos==="Todos..."||argsDocum.estadoos===""){
        xlsString1 = ['Fecha', 'Estado', 'Fecha Creac', 'Usuario Crea', 'Usuario Cierra', 'Tipo de OS', 'Categoría', 'Barrio', 'Recauda', 'Nodo', 'Dirección', 'Teléfono 1', 'Teléfono 2',
          'Contrato', 'Nombre(s)', 'Apellido(s)', '# OS', 'Ptos Adic', 'Observac al crear', 'Observac al cerrar', cicloFactEncab, direccionEnOSEncab, telefonoRef1Encab, telefonoRef2Encab, numeroDocEncab, codigoMarquillaEncab, cunEncab, estadoClienteEncab]
      }
      if(argsDocum.estadoos==="CERRADA"&&opciones1==="opcion4"){
        xlsString1 = ['Fecha', 'Estado', 'Fecha Creac', 'Usuario Crea', 'Usuario Cierra', 'Fecha Ejec', 'Tipo de OS', 'Categoría', 'Barrio', 'Recauda', 'Nodo', 'Dirección', 'Teléfono 1', 'Teléfono 2',
          'Contrato', 'Nombre(s)', 'Apellido(s)', '# OS', 'Ptos Adic', 'Observac al crear', 'Observac al cerrar', cicloFactEncab, direccionEnOSEncab, telefonoRef1Encab, telefonoRef2Encab, numeroDocEncab, codigoMarquillaEncab, cunEncab, estadoClienteEncab]
      }
      if(argsDocum.estadoos==="CERRADA"&&opciones1==="opcion5"){
        xlsString1 = ['Fecha', 'Estado', 'Usuario Cierra', 'Tipo de OS', 'Categoría', 'Barrio', 'Recauda', 'Nodo', 'Dirección', 'Contrato', 'Nombre(s)', 'Apellido(s)', '# OS',
          'Vendedor', 'Servicio', 'Valor cargo', cicloFactEncab, direccionEnOSEncab, telefonoRef1Encab, telefonoRef2Encab, numeroDocEncab, codigoMarquillaEncab, cunEncab, estadoClienteEncab]
      }
      if(argsDocum.estadoos==="CERRADA"&&opciones1==="opcion6"){
        xlsString1 = ['Fecha', 'Estado', 'Usuario Cierra', 'Tipo de OS', 'Categoría', 'Barrio', 'Recauda', 'Nodo', 'Dirección', 'Contrato', 'Nombre(s)', 'Apellido(s)', '# OS',
          'Vendedor', 'Servicio', 'Valor', cicloFactEncab, direccionEnOSEncab, telefonoRef1Encab, telefonoRef2Encab, numeroDocEncab, codigoMarquillaEncab, cunEncab, estadoClienteEncab]
      }
      xlsString.push(xlsString1)

      for(let i=0; i<listRtes.length; i++){
        let fechaOS = ""
        if(listRtes[i].fechaOS){
          fechaOS = listRtes[i].fechaOS
        }
        let estadoCliente = ""
        let cicloFact = "", direccionEnOS = "", telefonoRef1 = "", telefonoRef2 = "", numeroDoc = ""
        let codigoMarquilla = "", cun = ""
        if(this.props.empresa.empresaArchFE==="codisert"||this.props.empresa.empresaArchFE==="sinergy"||
            this.props.empresa.empresaArchFE==="conectic"||this.props.empresa.empresaArchFE==="supercable"||
            this.props.empresa.empresaArchFE==="supercablebq"){
          if(this.props.empresa.empresaArchFE==="codisert"||this.props.empresa.empresaArchFE==="supercablebq"){
            cicloFact = listRtes[i].cicloFact
          }
          if(this.props.empresa.empresaArchFE==="sinergy"){
            cicloFact = listRtes[i].descrGrupoAfin
          }
          if(this.props.empresa.empresaArchFE==="conectic"||this.props.empresa.empresaArchFE==="supercable"){
            estadoCliente = listRtes[i].estadoCliente
            cicloFact = listRtes[i].nombreBarrioEnOS
            direccionEnOS = listRtes[i].direccionEnOS
            telefonoRef1 = listRtes[i].telefonoRef1
            telefonoRef2 = listRtes[i].telefonoRef2
            numeroDoc = listRtes[i].numeroDoc
            codigoMarquilla = listRtes[i].codigoMarquilla
            cun = listRtes[i].cun
          }
        }
        // if(opciones1==="opcion4"||argsDocum.estadoos!=="CERRADA"){
        if(argsDocum.estadoos!=="CERRADA"&&argsDocum.estadoos!=="Todos..."&&argsDocum.estadoos!==""){
          xlsString1 = [fechaOS, listRtes[i].usuarioCreate, listRtes[i].estadoOS, listRtes[i].descrTipoOS, listRtes[i].descrCategOST,
            listRtes[i].nombreBarrio, listRtes[i].descrRecursoR, listRtes[i].descrNodo,
            listRtes[i].direccion, listRtes[i].telefono1, listRtes[i].telefono2,
            listRtes[i].contrato, listRtes[i].nombreCliente, listRtes[i].apellidoCliente,
            listRtes[i].numeroOS, listRtes[i].ptosAdic, listRtes[i].observacAB, cicloFact, direccionEnOS, telefonoRef1, telefonoRef2, numeroDoc, codigoMarquilla, cun, estadoCliente]
        }
        if(argsDocum.estadoos==="Todos..."||argsDocum.estadoos===""){
          xlsString1 = [fechaOS, listRtes[i].estadoOS, listRtes[i].fechaCreate,
            listRtes[i].usuarioCreate, listRtes[i].usuarioClose, listRtes[i].descrTipoOS, listRtes[i].descrCategOST,
            listRtes[i].nombreBarrio, listRtes[i].descrRecursoR, listRtes[i].descrNodo,
            listRtes[i].direccion, listRtes[i].telefono1, listRtes[i].telefono2,
            listRtes[i].contrato, listRtes[i].nombreCliente, listRtes[i].apellidoCliente,
            listRtes[i].numeroOS, listRtes[i].ptosAdic, listRtes[i].observacAB, listRtes[i].observacCE, cicloFact, direccionEnOS, telefonoRef1, telefonoRef2, numeroDoc, codigoMarquilla, cun, estadoCliente]
        }
        if(argsDocum.estadoos==="CERRADA"&&opciones1==="opcion4"){
          xlsString1 = [fechaOS, listRtes[i].estadoOS, listRtes[i].fechaCreate,
            listRtes[i].usuarioCreate, listRtes[i].usuarioClose,
            listRtes[i].fechaEjec, listRtes[i].descrTipoOS, listRtes[i].descrCategOST, listRtes[i].nombreBarrio,
            listRtes[i].descrRecursoR, listRtes[i].descrNodo,
            listRtes[i].direccion, listRtes[i].telefono1, listRtes[i].telefono2,
            listRtes[i].contrato, listRtes[i].nombreCliente, listRtes[i].apellidoCliente,
            listRtes[i].numeroOS, listRtes[i].ptosAdic, listRtes[i].observacAB, listRtes[i].observacCE, cicloFact, direccionEnOS, telefonoRef1, telefonoRef2, numeroDoc, codigoMarquilla, cun, estadoCliente]
        }

        if(argsDocum.estadoos==="CERRADA"&&opciones1==="opcion5"){
          xlsString1 = [fechaOS, listRtes[i].estadoOS, listRtes[i].usuarioClose, listRtes[i].descrTipoOS, listRtes[i].descrCategOST,
            listRtes[i].nombreBarrio, listRtes[i].descrRecursoR, listRtes[i].descrNodo,
            listRtes[i].direccion, listRtes[i].contrato, listRtes[i].nombreCliente,
            listRtes[i].apellidoCliente, listRtes[i].numeroOS, listRtes[i].descrRecursoV,
            listRtes[i].descripcionServicio, listRtes[i].valorTotal, cicloFact, direccionEnOS, telefonoRef1, telefonoRef2, numeroDoc, codigoMarquilla, cun, estadoCliente]
        }
        if(argsDocum.estadoos==="CERRADA"&&opciones1==="opcion6"){
          xlsString1 = [fechaOS, listRtes[i].estadoOS, listRtes[i].usuarioClose, listRtes[i].descrTipoOS, listRtes[i].descrCategOST,
            listRtes[i].nombreBarrio, listRtes[i].descrRecursoR, listRtes[i].descrNodo,
            listRtes[i].direccion, listRtes[i].contrato, listRtes[i].nombreCliente,
            listRtes[i].apellidoCliente, listRtes[i].numeroOS, listRtes[i].descrRecursoV,
            listRtes[i].descripcionServicio, listRtes[i].valorServicios, cicloFact, direccionEnOS, telefonoRef1, telefonoRef2, numeroDoc, codigoMarquilla, cun, estadoCliente]
        }
  
    // console.log(xlsString1)
        xlsString.push(xlsString1)
      }
  // console.log(xlsString)

      var wb = XLSX.utils.book_new();

      wb.Props = {
        Title: "SheetJS Tutorial",
        Subject: "Test",
        Author: "Red Stapler",
        CreatedDate: new Date(2017,12,19)
      };

      wb.SheetNames.push("OrdenServ");

      let ws_data = xlsString;

      let ws = XLSX.utils.aoa_to_sheet(ws_data);
      wb.Sheets["OrdenServ"] = ws;
      let wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});
      function s2ab(s) { 
        let buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
        let view = new Uint8Array(buf);  //create uint8array as viewer
        for (let i=0; i<s.length; i++) view[i] = s.charCodeAt(i) & 0xFF; //convert to octet
        return buf;    
      }
      saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), 'ordenserv.xlsx');
//FIN Exportar a XLS
    }
    if(targetName==="formato"){
      this.setState({stImpr: true})
    }else{
      this.setState({stImpr: false})
    }
    this.setState({imprSelecc: 0})

    console.log("listooooo")
  }

  async UNSAFE_componentWillMount(){
    if(this.state.argsDocum.desde===""){
      const argsDocum = this.state.argsDocum
      const response = await this.props.fecha({
        variables: {}
      });
      const {fechaFechaHoy} = await response.data.fecha
      argsDocum['desde'] = fechaFechaHoy.substr(0,10)
      argsDocum['hasta'] = fechaFechaHoy.substr(0,10)
      argsDocum['hoy'] = fechaFechaHoy.substr(0,10)
      this.setState(argsDocum)
    }
  }

  async componentDidUpdate(prevProps, prevState){
    if(this.props.argsSelDpto.codigoCiudad!==undefined&&this.props.argsSelDpto.codigoCiudad!==""){
      let miLista = document.getElementById("miLista1");
      if(miLista.options[miLista.selectedIndex].value!==this.props.argsSelDpto.codigoCiudad){
        const argsSelDpto = this.state.argsSelDpto
        argsSelDpto['nombreCiudad'] = "Todas..."
        argsSelDpto['codigoCiudad'] = ""
        argsSelDpto['codigoCiudadInterno'] = ""
        argsSelDpto['codBarrasRdo'] = ""
        this.setState({argsSelDpto})
      }
    }
    if(this.props.argsSelDpto.codigoZona!==undefined&&this.props.argsSelDpto.codigoZona!==""){
      let miLista = document.getElementById("miLista2");
      if(miLista.options[miLista.selectedIndex].value!==this.props.argsSelDpto.codigoZona){
        const argsSelDpto = this.state.argsSelDpto
        argsSelDpto['nombreZona'] = "Todas..."
        argsSelDpto['codigoZona'] = ""
        this.setState({argsSelDpto})
      }
    }
    if(this.props.argsSelDpto.codigoBarrio!==undefined&&this.props.argsSelDpto.codigoBarrio!==""){
      let miLista = document.getElementById("miLista3");
      if(miLista.options[miLista.selectedIndex].value!==this.props.argsSelDpto.codigoBarrio){
        const argsSelDpto = this.state.argsSelDpto
        argsSelDpto['nombreBarrio'] = "Todos..."
        argsSelDpto['codigoBarrio'] = ""
        argsSelDpto['codigoTipoDocT'] = ""
        argsSelDpto['numeroDocumT'] = ""
        argsSelDpto['descrRecursoT'] = ""
        argsSelDpto['codigoTipoDocR'] = ""
        argsSelDpto['numeroDocumR'] = ""
        argsSelDpto['descrRecursoR'] = ""
        this.setState({argsSelDpto})
      }
    }
    if(this.props.argsSelDpto.descrDpto!==this.state.argsDocum.descrDpto||
        this.props.argsSelDpto.nombreCiudad!==this.state.argsDocum.nombreCiudad||
        this.props.argsSelDpto.nombreZona!==this.state.argsDocum.nombreZona||
        this.props.argsSelDpto.nombreBarrio!==this.state.argsDocum.nombreBarrio){
      const argsDocum = this.state.argsDocum
      argsDocum.descrDpto = this.props.argsSelDpto.descrDpto
      argsDocum.nombreCiudad = this.props.argsSelDpto.nombreCiudad
      argsDocum.nombreZona = this.props.argsSelDpto.nombreZona
      argsDocum.nombreBarrio = this.props.argsSelDpto.nombreBarrio
      this.setState({argsDocum});

      this.setState({stImpr: false})

      this.setState({argsSelDpto: this.props.argsSelDpto})
      this.setState({listRtes: []})
      await this.props.allOdeSRtes.refetch()
    }
    // if(this.props.argsSelDpto!==prevProps.argsSelDpto){
    //   this.setState({stImpr: false})

    //   this.setState({argsSelDpto: this.props.argsSelDpto})
    //   this.setState({listRtes: []})
    //   await this.props.allOdeSRtes.refetch()
    // }
    if(this.state.stImpr!==prevState.stImpr){
      this.setState({stImpr: false})

      await this.props.allOdeSRtes.refetch()
      const myBtn = document.getElementById("pantalla");
      myBtn.click()
      }
    }

  render(){
    const {argsDocum, opciones, opciones1, stImpr, imprSelecc, listRtes, totOS,
            confirmaAct, errors} = this.state;
    const a151001 = this.props.autorizacUA.findIndex( autorizac => autorizac === "151001" );
    const a151005 = this.props.autorizacUA.findIndex( autorizac => autorizac === "151005" );
    const a151010 = this.props.autorizacUA.findIndex( autorizac => autorizac === "151010" );

    if(this.props.codigoCiudadUA!=="Todas..."){
      let dpto = document.getElementById("miLista");
      if(dpto){
        dpto.options.selectedIndex = 0
      }
    }

    let colecc = selDirmayor(this.props.list1, this.props.argsSelDpto, this.props.codigoCiudadUA)
    let listCiu = colecc.listCiu
    let listZon = colecc.listZon
    let listBar = colecc.listBar

    let listaTOS = []
    if(this.props.allTiposOS.allTiposOS){
      listaTOS = this.props.allTiposOS.allTiposOS
    }

    let listaCOS = []
    if(this.props.allClasifOST.allClasifOST){
      listaCOS = this.props.allClasifOST.allClasifOST
    }
    let listaCateg = []

    if(this.props.allCategOST.allCategOST){
      if(argsDocum.descrTipoOS&&argsDocum.descrTipoOS!=="Todos..."){
        listaCateg = this.props.allCategOST.allCategOST.filter(categ => categ.descrTipoOS===argsDocum.descrTipoOS)
      }else{
        listaCateg = this.props.allCategOST.allCategOST
      }
      // if(argsDocum.descrCategOST&&argsDocum.descrCategOST!=="Todas..."&&
      //     argsDocum.descrTipoOS&&argsDocum.descrTipoOS!=="Todos..."){
      //   const indexSearchCateg = listaCateg.findIndex( categ =>  categ.descrTipoOS===argsDocum.descrTipoOS && categ.descrCategOST===argsDocum.descrCategOST );
      //   console.log(indexSearchCateg)
      //   if(indexSearchCateg===-1){
      //     var descrCategOST = document.getElementById("miListaCateg");
      //     descrCategOST.options.selectedIndex = 0
      //   }
      // }
      // console.log(argsDocum)
    }

    let listOSCl = []
    let imprOSCl = true
    // console.log(listRtes)
    // console.log(this.props.allOdeSRtes.allOdeSRtes)
    // console.log(stImpr, imprOSCl)
    if(stImpr){
      listRtes.forEach((elemento, i) => {
        if(imprSelecc===0||(imprSelecc!==0&&imprSelecc===elemento.numeroOS)){
          const indexSearchOS = this.props.allOdeSRtes.allOdeSRtes.findIndex( odes => odes.numeroOS === elemento.numeroOS );
          if(indexSearchOS===-1){
            imprOSCl = false
          }
//           const indexSearchCl = this.props.allCliBasico.allCliBasico.findIndex( cliente => cliente.contrato === elemento.contrato );
// // console.log("render")
//           if(indexSearchCl===-1){
//             imprOSCl = false
//           }
          // console.log(elemento.cliente)
          if(!elemento.cliente){
            imprOSCl = false
          }
        // console.log(this.props.allOdeSRtes.allOdeSRtes[indexSearchOS])
        // listOSCl.push({listOS: this.props.allOdeSRtes.allOdeSRtes[indexSearchOS], cliente: this.props.allCliBasico.allCliBasico[indexSearchCl]})
          // console.log(i, elemento.permImprimir)
          if(elemento.permImprimir==="SI"){
            listOSCl.push({listOS: this.props.allOdeSRtes.allOdeSRtes[indexSearchOS], cliente: elemento.cliente[0]})
          }
        }
      })
    }
// console.log(listOSCl)
    // console.log(this.props.allOdeSRtes.allOdeSRtes)

    // let fechaHoy = new Date()
    // fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())

    // console.log(this.props.allOdeSRtes.allOdeSRtes)
    // console.log(this.props.allServicios.allServicios)
// console.log(this.props.list2)
// console.log(this.state.argsSelDpto)
// console.log(argsDocum)
// console.log(opciones, opciones1)
// console.log(argsDocum.estadoos)
    let hoy = argsDocum.hoy
    return(
      <div>
        <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
          <i className="large plus yellow icon"></i>
          Ordenes de servicio
        </button>
        <div>
          <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
            <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.handleSubmit(ev, argsDocum, opciones, opciones1):()=>{}}>
              <div>
                <div className="ui two column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '25%'}}>
                      <h1 style={{color: '#2C7744'}}>Ordenes de servicio</h1>
                    </div>
                    <div className="column" style={{width: '35%'}}>
                      <fieldset><legend style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;&nbsp;&nbsp;Opciones&nbsp;&nbsp;&nbsp;</legend>
                        <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones" value="opcion1" defaultChecked="true" onChange={this.handleChange}></input>
                        <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Sin imprimir&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
                        <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones" value="opcion2" onChange={this.handleChange}></input>
                        <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Impresas&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
                        <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones" value="opcion3" onChange={this.handleChange}></input>
                        <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Todas</label>
                      </fieldset>
                    </div>
                    <div className="column" style={{width: '40%'}}>
                      {argsDocum.estadoos==="CERRADA" &&
                        <div>
                          <fieldset><legend style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;&nbsp;&nbsp;Tipo de reporte&nbsp;&nbsp;&nbsp;</legend>
                            <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones1" value="opcion4" defaultChecked="true" onChange={this.handleChange}></input>
                            <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;General&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
                            <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones1" value="opcion5" onChange={this.handleChange}></input>
                            <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Con cargos&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
                            <input style={{height: '1.1em', width: '1.2em'}} type="radio" name="opciones1" value="opcion6" onChange={this.handleChange}></input>
                            <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Con nueva tarifa</label>
                          </fieldset>
                        </div>
                      }
                    </div>
                  </div>
                </div>
                <hr></hr>
                <div>
                  <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                    <input style={{margin: '0.4em 0em 0em 0em'}} type='checkbox' name="checkDiasMoraIni" checked={argsDocum.checkDiasMoraIni} onChange={this.handleChange}/>
                    &nbsp;&nbsp;Solo las que tengan Puntos Adicionales
                  </p>
                </div>
                <hr></hr>
                <div className="ui three column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '20%'}}>
                      <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Estado
                      </p>
                      <Form.Field>
                        <Lista styles={this.props.styles} list={this.props.list2} argsDocum={argsDocum} handleChange={this.handleChange}/>
                      </Form.Field>
                    </div>
                    <div className="column" style={{width: '30%'}}>
                      <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Tipo de Orden de Servicio
                      </p>
                      <Form.Field>
                        <ListaTOS styles={this.props.styles} list={listaTOS} handleChange={this.handleChange}/>
                      </Form.Field>
                    </div>
                    <div className="column" style={{width: '25%'}}>
                      {(argsDocum.estadoos!=="ABIERTA"||this.props.empresa.empresaArchFE==="codisert") &&
                        <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          Desde
                        </p>
                      }
                      {(argsDocum.estadoos!=="ABIERTA"||this.props.empresa.empresaArchFE==="codisert") &&
                        <Form.Field>
                          <input style={this.props.styles.input} type='date' name="desde" id="desde" value={argsDocum.desde} onChange={this.handleChange}/>
                        </Form.Field>
                      }
                    </div>
                    <div className="column" style={{width: '25%'}}>
                      {(argsDocum.estadoos!=="ABIERTA"||this.props.empresa.empresaArchFE==="codisert") &&
                        <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          Hasta
                        </p>
                      }
                      {(argsDocum.estadoos!=="ABIERTA"||this.props.empresa.empresaArchFE==="codisert") &&
                        <Form.Field>
                          <input style={this.props.styles.input} type='date' name="hasta" id="hasta" value={argsDocum.hasta} onChange={this.handleChange}/>
                        </Form.Field>
                      }
                    </div>
                  </div>
                </div>

                <div className="ui two column stackable grid" style={{marginTop: '0em', paddingTop: '0em'}}>
                  <div className="row container" style={{marginTop: '0em', paddingTop: '0em'}}>
                    <div className="column" style={{width: '50%'}}>
                      <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Clasificación
                      </p>
                      <Form.Field>
                        <ListaCOS styles={this.props.styles} list={listaCOS} handleChange={this.handleChange}/>
                      </Form.Field>
                    </div>
                    <div className="column" style={{width: '50%'}}>
                      <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Categoría
                      </p>
                      <Form.Field>
                        <ListaCateg styles={this.props.styles} list={listaCateg} handleChange={this.handleChange}/>
                      </Form.Field>
                    </div>
                  </div>
                </div>
                <hr></hr>

                <div className="ui two column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '50%'}}>
                      <Form.Field>
                        <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          Departamento
                        </label>
                        <ListaDe list={this.props.list1} styles={this.props.styles}
                          handleLista={this.props.handleLista} codigoCiudadUA={this.props.codigoCiudadUA}
                          codigoDptoUA={this.props.codigoDptoUA}/>
                      </Form.Field>
                    </div>
                    <div className="column" style={{width: '50%'}}>
                      <Form.Field>
                        <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          Ciudad
                        </label>
                        <ListaCi list={listCiu} styles={this.props.styles}
                          handleLista1={this.props.handleLista1} argsSelDpto={this.props.argsSelDpto}
                          codigoCiudadUA={this.props.codigoCiudadUA}/>
                      </Form.Field>
                    </div>
                    <div className="column" style={{width: '50%'}}>
                      <Form.Field>
                        <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          Zona
                        </label>
                        <ListaZo list={listZon} styles={this.props.styles} handleLista2={this.props.handleLista2}
                          argsSelCiu={this.props.argsSelCiu}/>
                      </Form.Field>
                    </div>
                    <div className="column" style={{width: '50%'}}>
                      <Form.Field>
                        <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          Barrio
                        </label>
                        <ListaBa list={listBar} styles={this.props.styles} handleLista3={this.props.handleLista3}
                          argsSelZon={this.props.argsSelZon}/>
                      </Form.Field>
                    </div>
                  </div>
                </div>
                <hr></hr>
                <div className="ui two column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '50%'}}>
                      <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Recurso del Area TECNICA
                      </p>
                      <Form.Field>
                        <ListaTecnica list={this.props.list} styles={this.props.styles} handleChange={this.handleChange}/>
                      </Form.Field>
                    </div>
                    <div className="column" style={{width: '50%'}}>
                      <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Recurso del Area de VENTAS
                      </p>
                      <Form.Field>
                        <ListaVentas list={this.props.list3} styles={this.props.styles} handleChange={this.handleChange}/>
                      </Form.Field>
                    </div>
                  </div>
                </div>
                {(this.props.empresa.empresaArchFE==="conectic"||this.props.empresa.empresaArchFE==="supercable") &&
                  <div className="ui two column stackable grid">
                    <div className="row container">
                      <div className="column" style={{width: '50%'}}>
                        <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          Recurso del Area RECAUDO
                        </p>
                        <Form.Field>
                          <ListaRecaudo list={this.props.list4} styles={this.props.styles} handleChange={this.handleChange}/>
                        </Form.Field>
                      </div>
                    </div>
                  </div>
                }
                <hr></hr>

                <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                  Total OS: {totOS}
                </p>

                <div className="ui two column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '25%'}}>
                      <Button id="pantalla" name="pantalla" style={this.props.styles.confirmar} onClick={(ev)=>this.handleSubmit(ev, argsDocum, opciones, opciones1)} fluid>
                        VER EN PANTALLA
                      </Button>
                    </div>
                    {a151001!==-1 &&
                    <div className="column" style={{width: '25%'}}>
                      <Button id="excel" name="excel" style={this.props.styles.confirmar} onClick={(ev)=>this.handleSubmit(ev, argsDocum, opciones, opciones1)} fluid>
                        ARCHIVO EXCEL
                      </Button>
                    </div>
                    }
                    {a151005!==-1 &&
                    <div className="column" style={{width: '25%'}}>
                      <Button id="pdf" name="pdf" style={this.props.styles.confirmar} onClick={(ev)=>this.handleSubmit(ev, argsDocum, opciones, opciones1)} fluid>
                        ARCHIVO PDF
                      </Button>
                    </div>
                    }
                    {((a151010!==-1&&opciones1==="opcion4")||argsDocum.estadoos!=="CERRADA") &&
                      <div className="column" style={{width: '25%'}}>
                        <Button id="formato" name="formato" style={this.props.styles.confirmar} onClick={(ev)=>this.handleSubmit(ev, argsDocum, opciones, opciones1)} fluid>
                          FORMATO POR OS
                        </Button>

                        {/* {(stImpr&&imprOSCl) && */}
                        {(imprOSCl) &&
                          <ImprOS listOSCl={listOSCl} empresa={this.props.empresa} stImpr={stImpr} hoy={hoy}/>
                        }
                      </div>
                    }
                  </div>
                </div>
                <hr></hr>
                <div style={{height: '40em', overflow: 'auto'}}>
                {(argsDocum.estadoos!=="CERRADA"&&argsDocum.estadoos!=="Todos..."&&argsDocum.estadoos!=="") &&
                  <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                    <thead className=''>
                      <tr className=''>
                        <th className=''>Fecha</th>
                        <th className=''>Usuario Crea</th>
                        <th className=''>Estado</th>
                        <th className=''>Tipo de OS</th>
                        <th className=''>Categoría</th>
                        {/* <th className=''>Ciudad</th>
                        <th className=''>Zona</th> */}
                        <th className=''>Barrio</th>
                        <th className=''>Recauda</th>
                        <th className=''>Nodo</th>
                        <th className=''>Dirección</th>
                        {/* <th className=''>Recurso</th> */}
                        <th className=''>Contrato</th>
                        <th className=''>Nombre(s)</th>
                        <th className=''>Apellido(s)</th>
                        <th className=''># OS</th>
                        <th className=''>Ptos Adic</th>
                        <th className=''>Observac al crear</th>
                        {(this.props.empresa.empresaArchFE==="codisert"||this.props.empresa.empresaArchFE==="supercablebq") &&
                          <th className=''>Ciclo</th>
                        }
                        {this.props.empresa.empresaArchFE==="sinergy" &&
                          <th className=''>Grupo Afinidad</th>
                        }
                        {(this.props.empresa.empresaArchFE==="conectic"||this.props.empresa.empresaArchFE==="supercable") &&
                          <th className=''>Barrio en OS</th>
                        }
                        {(this.props.empresa.empresaArchFE==="conectic"||this.props.empresa.empresaArchFE==="supercable") &&
                          <th className=''>Dirección en OS</th>
                        }
                        {(this.props.empresa.empresaArchFE==="conectic"||this.props.empresa.empresaArchFE==="supercable") &&
                          <th className=''>Tel Ref 1</th>
                        }
                        {(this.props.empresa.empresaArchFE==="conectic"||this.props.empresa.empresaArchFE==="supercable") &&
                          <th className=''>Tel Ref 2</th>
                        }
                        {(this.props.empresa.empresaArchFE==="conectic"||this.props.empresa.empresaArchFE==="supercable") &&
                          <th className=''>Documento</th>
                        }
                        {(this.props.empresa.empresaArchFE==="conectic"||this.props.empresa.empresaArchFE==="supercable") &&
                          <th className=''>Marquilla</th>
                        }
                        {(this.props.empresa.empresaArchFE==="conectic"||this.props.empresa.empresaArchFE==="supercable") &&
                          <th className=''>CUN</th>
                        }
                        {(this.props.empresa.empresaArchFE==="conectic"||this.props.empresa.empresaArchFE==="supercable") &&
                          <th className=''>Estado cliente</th>
                        }
                        <th className=''>Imprimir</th>
                      </tr>
                    </thead>
                    <ListaOS list={listRtes} argsDocum={argsDocum} opciones1={opciones1}
                      empresaArchFE={this.props.empresa.empresaArchFE} handleImprOSSelecc={this.handleImprOSSelecc}/>
                  </table>
                }
                {(argsDocum.estadoos==="Todos..."||argsDocum.estadoos==="") &&
                  <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                    <thead className=''>
                      <tr className=''>
                        <th className=''>Fecha</th>
                        <th className=''>Estado</th>
                        <th className=''>Fecha Creac</th>
                        <th className=''>Usuario Crea</th>
                        <th className=''>Usuario Cierra</th>
                        <th className=''>Tipo de OS</th>
                        <th className=''>Categoría</th>
                        {/* <th className=''>Ciudad</th>
                        <th className=''>Zona</th> */}
                        <th className=''>Barrio</th>
                        <th className=''>Recauda</th>
                        <th className=''>Nodo</th>
                        <th className=''>Dirección</th>
                        {/* <th className=''>Recurso</th> */}
                        <th className=''>Contrato</th>
                        <th className=''>Nombre(s)</th>
                        <th className=''>Apellido(s)</th>
                        <th className=''># OS</th>
                        <th className=''>Ptos Adic</th>
                        <th className=''>Observac al crear</th>
                        <th className=''>Observac al cerrar</th>
                        {(this.props.empresa.empresaArchFE==="codisert"||this.props.empresa.empresaArchFE==="supercablebq") &&
                          <th className=''>Ciclo</th>
                        }
                        {this.props.empresa.empresaArchFE==="sinergy" &&
                          <th className=''>Grupo Afinidad</th>
                        }
                        {(this.props.empresa.empresaArchFE==="conectic"||this.props.empresa.empresaArchFE==="supercable") &&
                          <th className=''>Barrio en OS</th>
                        }
                        {(this.props.empresa.empresaArchFE==="conectic"||this.props.empresa.empresaArchFE==="supercable") &&
                          <th className=''>Dirección en OS</th>
                        }
                        {(this.props.empresa.empresaArchFE==="conectic"||this.props.empresa.empresaArchFE==="supercable") &&
                          <th className=''>Tel Ref 1</th>
                        }
                        {(this.props.empresa.empresaArchFE==="conectic"||this.props.empresa.empresaArchFE==="supercable") &&
                          <th className=''>Tel Ref 2</th>
                        }
                        {(this.props.empresa.empresaArchFE==="conectic"||this.props.empresa.empresaArchFE==="supercable") &&
                          <th className=''>Documento</th>
                        }
                        {(this.props.empresa.empresaArchFE==="conectic"||this.props.empresa.empresaArchFE==="supercable") &&
                          <th className=''>Marquilla</th>
                        }
                        {(this.props.empresa.empresaArchFE==="conectic"||this.props.empresa.empresaArchFE==="supercable") &&
                          <th className=''>CUN</th>
                        }
                        {(this.props.empresa.empresaArchFE==="conectic"||this.props.empresa.empresaArchFE==="supercable") &&
                          <th className=''>Estado cliente</th>
                        }
                        <th className=''>Imprimir</th>
                      </tr>
                    </thead>
                    <ListaOS list={listRtes} argsDocum={argsDocum} opciones1={opciones1}
                      empresaArchFE={this.props.empresa.empresaArchFE} handleImprOSSelecc={this.handleImprOSSelecc}/>
                  </table>
                }
                {(argsDocum.estadoos==="CERRADA"&&opciones1==="opcion4") &&
                  <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                    <thead className=''>
                      <tr className=''>
                        <th className=''>Fecha</th>
                        <th className=''>Estado</th>
                        <th className=''>Fecha Creac</th>
                        <th className=''>Usuario Crea</th>
                        <th className=''>Usuario Cierra</th>
                        <th className=''>Fecha Ejec</th>
                        <th className=''>Tipo de OS</th>
                        <th className=''>Categoría</th>
                        {/* <th className=''>Ciudad</th>
                        <th className=''>Zona</th> */}
                        <th className=''>Barrio</th>
                        <th className=''>Recauda</th>
                        <th className=''>Nodo</th>
                        <th className=''>Dirección</th>
                        {/* <th className=''>Recurso</th> */}
                        <th className=''>Contrato</th>
                        <th className=''>Nombre(s)</th>
                        <th className=''>Apellido(s)</th>
                        <th className=''># OS</th>
                        <th className=''>Ptos Adic</th>
                        <th className=''>Observac al crear</th>
                        <th className=''>Observac al cerrar</th>
                        {(this.props.empresa.empresaArchFE==="codisert"||this.props.empresa.empresaArchFE==="supercablebq") &&
                          <th className=''>Ciclo</th>
                        }
                        {this.props.empresa.empresaArchFE==="sinergy" &&
                          <th className=''>Grupo Afinidad</th>
                        }
                        {(this.props.empresa.empresaArchFE==="conectic"||this.props.empresa.empresaArchFE==="supercable") &&
                          <th className=''>Barrio en OS</th>
                        }
                        {(this.props.empresa.empresaArchFE==="conectic"||this.props.empresa.empresaArchFE==="supercable") &&
                          <th className=''>Dirección en OS</th>
                        }
                        {(this.props.empresa.empresaArchFE==="conectic"||this.props.empresa.empresaArchFE==="supercable") &&
                          <th className=''>Tel Ref 1</th>
                        }
                        {(this.props.empresa.empresaArchFE==="conectic"||this.props.empresa.empresaArchFE==="supercable") &&
                          <th className=''>Tel Ref 2</th>
                        }
                        {(this.props.empresa.empresaArchFE==="conectic"||this.props.empresa.empresaArchFE==="supercable") &&
                          <th className=''>Documento</th>
                        }
                        {(this.props.empresa.empresaArchFE==="conectic"||this.props.empresa.empresaArchFE==="supercable") &&
                          <th className=''>Marquilla</th>
                        }
                        {(this.props.empresa.empresaArchFE==="conectic"||this.props.empresa.empresaArchFE==="supercable") &&
                          <th className=''>CUN</th>
                        }
                        {(this.props.empresa.empresaArchFE==="conectic"||this.props.empresa.empresaArchFE==="supercable") &&
                          <th className=''>Estado cliente</th>
                        }
                        <th className=''>Imprimir</th>
                      </tr>
                    </thead>
                    <ListaOS list={listRtes} argsDocum={argsDocum} opciones1={opciones1}
                      empresaArchFE={this.props.empresa.empresaArchFE} handleImprOSSelecc={this.handleImprOSSelecc}/>
                  </table>
                }

                {(argsDocum.estadoos==="CERRADA"&&opciones1==="opcion5") &&
                  <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                    <thead className=''>
                      <tr className=''>
                        <th className=''>Fecha</th>
                        <th className=''>Estado</th>
                        <th className=''>Usuario Cierra</th>
                        <th className=''>Tipo de OS</th>
                        <th className=''>Categoría</th>
                        {/* <th className=''>Ciudad</th>
                        <th className=''>Zona</th> */}
                        <th className=''>Barrio</th>
                        <th className=''>Recauda</th>
                        <th className=''>Nodo</th>
                        <th className=''>Dirección</th>
                        {/* <th className=''>Recurso</th> */}
                        <th className=''>Contrato</th>
                        <th className=''>Nombre(s)</th>
                        <th className=''>Apellido(s)</th>
                        <th className=''># OS</th>
                        <th className=''>Vendedor</th>
                        <th className=''>Servicio</th>
                        <th className=''>Valor cargo</th>
                        {(this.props.empresa.empresaArchFE==="codisert"||this.props.empresa.empresaArchFE==="supercablebq") &&
                          <th className=''>Ciclo</th>
                        }
                        {this.props.empresa.empresaArchFE==="sinergy" &&
                          <th className=''>Grupo Afinidad</th>
                        }
                        {(this.props.empresa.empresaArchFE==="conectic"||this.props.empresa.empresaArchFE==="supercable") &&
                          <th className=''>Barrio en OS</th>
                        }
                        {(this.props.empresa.empresaArchFE==="conectic"||this.props.empresa.empresaArchFE==="supercable") &&
                          <th className=''>Dirección en OS</th>
                        }
                        {(this.props.empresa.empresaArchFE==="conectic"||this.props.empresa.empresaArchFE==="supercable") &&
                          <th className=''>Tel Ref 1</th>
                        }
                        {(this.props.empresa.empresaArchFE==="conectic"||this.props.empresa.empresaArchFE==="supercable") &&
                          <th className=''>Tel Ref 2</th>
                        }
                        {(this.props.empresa.empresaArchFE==="conectic"||this.props.empresa.empresaArchFE==="supercable") &&
                          <th className=''>Documento</th>
                        }
                        {(this.props.empresa.empresaArchFE==="conectic"||this.props.empresa.empresaArchFE==="supercable") &&
                          <th className=''>Marquilla</th>
                        }
                        {(this.props.empresa.empresaArchFE==="conectic"||this.props.empresa.empresaArchFE==="supercable") &&
                          <th className=''>CUN</th>
                        }
                        {(this.props.empresa.empresaArchFE==="conectic"||this.props.empresa.empresaArchFE==="supercable") &&
                          <th className=''>Estado cliente</th>
                        }
                      </tr>
                    </thead>
                    <ListaOS list={listRtes} argsDocum={argsDocum} opciones1={opciones1}
                      empresaArchFE={this.props.empresa.empresaArchFE} handleImprOSSelecc={this.handleImprOSSelecc}/>
                  </table>
                }
                {(argsDocum.estadoos==="CERRADA"&&opciones1==="opcion6") &&
                  <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                    <thead className=''>
                      <tr className=''>
                        <th className=''>Fecha</th>
                        <th className=''>Estado</th>
                        <th className=''>Usuario Cierra</th>
                        <th className=''>Tipo de OS</th>
                        <th className=''>Categoría</th>
                        {/* <th className=''>Ciudad</th>
                        <th className=''>Zona</th> */}
                        <th className=''>Barrio</th>
                        <th className=''>Recauda</th>
                        <th className=''>Nodo</th>
                        <th className=''>Dirección</th>
                        {/* <th className=''>Recurso</th> */}
                        <th className=''>Contrato</th>
                        <th className=''>Nombre(s)</th>
                        <th className=''>Apellido(s)</th>
                        <th className=''># OS</th>
                        <th className=''>Vendedor</th>
                        <th className=''>Servicio</th>
                        <th className=''>Valor</th>
                        {(this.props.empresa.empresaArchFE==="codisert"||this.props.empresa.empresaArchFE==="supercablebq") &&
                          <th className=''>Ciclo</th>
                        }
                        {this.props.empresa.empresaArchFE==="sinergy" &&
                          <th className=''>Grupo Afinidad</th>
                        }
                        {(this.props.empresa.empresaArchFE==="conectic"||this.props.empresa.empresaArchFE==="supercable") &&
                          <th className=''>Barrio en OS</th>
                        }
                        {(this.props.empresa.empresaArchFE==="conectic"||this.props.empresa.empresaArchFE==="supercable") &&
                          <th className=''>Dirección en OS</th>
                        }
                        {(this.props.empresa.empresaArchFE==="conectic"||this.props.empresa.empresaArchFE==="supercable") &&
                          <th className=''>Tel Ref 1</th>
                        }
                        {(this.props.empresa.empresaArchFE==="conectic"||this.props.empresa.empresaArchFE==="supercable") &&
                          <th className=''>Tel Ref 2</th>
                        }
                        {(this.props.empresa.empresaArchFE==="conectic"||this.props.empresa.empresaArchFE==="supercable") &&
                          <th className=''>Documento</th>
                        }
                        {(this.props.empresa.empresaArchFE==="conectic"||this.props.empresa.empresaArchFE==="supercable") &&
                          <th className=''>Marquilla</th>
                        }
                        {(this.props.empresa.empresaArchFE==="conectic"||this.props.empresa.empresaArchFE==="supercable") &&
                          <th className=''>CUN</th>
                        }
                        {(this.props.empresa.empresaArchFE==="conectic"||this.props.empresa.empresaArchFE==="supercable") &&
                          <th className=''>Estado cliente</th>
                        }
                      </tr>
                    </thead>
                    <ListaOS list={listRtes} argsDocum={argsDocum} opciones1={opciones1}
                      empresaArchFE={this.props.empresa.empresaArchFE} handleImprOSSelecc={this.handleImprOSSelecc}/>
                  </table>
                }
                </div>
              </div>
              {
                errors.length?<Message negative header="Los siguientes errores:"
                list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
              }

            </Form>
          </div>
        </div>
      </div>
    )
  }
}

export default compose(
  // graphql(queries.query.allCliBasico, {name:'allCliBasico', options: (props) => {return {variables: argsBuscarCL}}}),
  graphql(queries.query.allOdeSRtes, {name:'allOdeSRtes', options: (props) => {return {variables: argsBuscarOS}}}),

  graphql(queries.query.allTiposOS, {name:'allTiposOS'}),
  graphql(queries.query.allClasifOST, {name:'allClasifOST'}),
  graphql(queries.query.allCategOST, {name:'allCategOST'}),

  graphql(queries.query.allServicios, {name:'allServicios', options: (props) => {return {variables: {paraProcMasDX: "SI"}}}}),

  graphql(queries.mutation.fecha, {name:'fecha'}),
)(RtesOS2)
